import React from 'react';
import { FaShoppingCart, FaStore, FaArrowRight } from 'react-icons/fa';

const CartSummaryRenderer = ({ data, onCheckout }) => {
  const { totalItems, shops, grandTotal, currency } = data;

  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      {/* Header */}
      <div className="bg-gray-50 px-4 py-3 border-b border-gray-200">
        <div className="flex items-center space-x-2">
          <FaShoppingCart className="text-blue-600" />
          <h3 className="font-semibold text-gray-900">Your Cart</h3>
          <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2 py-1 rounded-full">
            {totalItems} items
          </span>
        </div>
      </div>

      {/* Shop sections */}
      <div className="divide-y divide-gray-200">
        {shops.map((shop, index) => (
          <div key={shop.shopId} className="p-4">
            {/* Shop header */}
            <div className="flex items-center space-x-3 mb-3">
              {shop.shopLogo && (
                <img 
                  src={shop.shopLogo} 
                  alt={shop.shopName}
                  className="w-8 h-8 rounded-lg object-cover"
                />
              )}
              <div>
                <h4 className="font-medium text-gray-900">{shop.shopName}</h4>
                <p className="text-sm text-gray-500">{shop.items.length} items</p>
              </div>
            </div>

            {/* Items */}
            <div className="space-y-3 mb-4">
              {shop.items.map((item, itemIndex) => (
                <div key={`${item.productId}-${itemIndex}`} className="flex items-center space-x-3 bg-gray-50 rounded-lg p-3">
                  {item.image && (
                    <img 
                      src={item.image} 
                      alt={item.name}
                      className="w-12 h-12 rounded-lg object-cover"
                    />
                  )}
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-gray-900 truncate">
                      {item.name && item.name !== `Product ${item.productId}` 
                        ? item.name 
                        : `Product ${item.productId}`}
                    </p>
                    {item.description && (
                      <p className="text-xs text-gray-500 truncate mt-1">{item.description}</p>
                    )}
                    <p className="text-sm text-gray-500">Qty: {item.quantity}</p>
                    {item.sku && (
                      <p className="text-xs text-gray-400">SKU: {item.sku}</p>
                    )}
                  </div>
                  <div className="text-sm font-semibold text-gray-900">
                    {item.currency} ${item.price ? item.price.toFixed(2) : '0.00'}
                  </div>
                </div>
              ))}
            </div>

            {/* Checkout button at bottom */}
            <div className="flex justify-end">
              <button 
                onClick={() => onCheckout && onCheckout()}
                className="bg-blue-600 text-white px-6 py-3 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors flex items-center space-x-2 w-full justify-center"
              >
                <span>Checkout</span>
                <span className="font-semibold">{currency} ${shop.subtotal ? shop.subtotal.toFixed(2) : '0.00'}</span>
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Grand total */}
      {shops.length > 1 && (
        <div className="bg-gray-50 px-4 py-3 border-t border-gray-200">
          <div className="flex items-center justify-between">
            <span className="font-semibold text-gray-900">Grand Total</span>
            <span className="font-bold text-lg text-gray-900">
              {currency} ${grandTotal ? grandTotal.toFixed(2) : '0.00'}
            </span>
          </div>
          <p className="text-xs text-gray-500 mt-1">
            Checkout with each shop separately
          </p>
        </div>
      )}
    </div>
  );
};

export default CartSummaryRenderer;
